<div  [ngClass]="{'d-flex justify-content-center': center, 'd-flex align-items-center h-100': alignMiddle }">
  <div class="spinner-border text-primary" style.width="{{size}}rem" style.height="{{size}}rem" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>